import React, { useState } from 'react';
import OrderListTemplate from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { useDefaultQueryFields } from '../order.effect';
import { OrderAuditInfo } from '../components/OrderAuditInfo';

/**
 * 所有已审订单列表页
 */
const OrderAllAuditList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  /**
   * 触发列表重载
   */
  const reloadList = () => setRefreshKey((k) => k + 1);

  const queryFields = useDefaultQueryFields(OrderTabScene.GroupAllAuditDone);

  const targets: OrderTriggerTarget[] = ['auditView'];

  const renderListInfo = (order: MergedOrder) => <OrderAuditInfo order={order} />;

  const renderListActions = (order: MergedOrder) => {
    return (
      <OrderTriggerActionMap layout="list" targets={targets} order={order} onReload={reloadList} />
    );
  };

  return (
    <OrderTriggerActionProvider onReload={reloadList}>
      <OrderListTemplate
        title="所有已审"
        refreshKey={refreshKey}
        tabScene={OrderTabScene.GroupAllAuditDone}
        defaultScene="tab_all_audit_done"
        queryFields={queryFields}
        viewModes={[
          { mode: 'list', label: '订单页', renderActions: renderListActions, renderInfo: renderListInfo },
          { 
            mode: 'table', 
            label: '表格页',
            showField: 'auditStep',
            // renderActions: renderTableActions,
          },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default OrderAllAuditList;
